import styled, { css } from 'styled-components';

import { pxToRem } from '../../../utils/styles';

export const SpinnerContainer = styled.div`
  &&& {
    display: flex;
    min-height: 50vh;
    justify-content: center;
    align-items: center;
  }
`;

export const ProductListWrapper = styled.div<{ $widgetType?: string }>`
  &&& {
    ${({ $widgetType }) =>
      $widgetType === 'modal' &&
      css`
        display: flex;
        align-items: center;
        justify-content: center;
        gap: ${pxToRem(16)};
        @media (max-width: 1066px) {
          padding: ${pxToRem(15)};
        }
      `};
  }
`;
